import { Banner as Banner$1, BannerTitle, BannerDescription, BannerPrimaryAction, BannerSecondaryAction } from './Banner.js';

const Banner = Object.assign(Banner$1, {
  Title: BannerTitle,
  Description: BannerDescription,
  PrimaryAction: BannerPrimaryAction,
  SecondaryAction: BannerSecondaryAction
});

export { Banner };
